import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=1502c65a&scoped=true"
import script from "./search.component.vue?vue&type=script&lang=ts"
export * from "./search.component.vue?vue&type=script&lang=ts"
import style0 from "./search.component.vue?vue&type=style&index=0&id=1502c65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1502c65a",
  null
  
)

export default component.exports